<template>
  <div class="d2-plan-card-item" :class="{ 'current': plansListDData.plan_d_text == '使用中' || plansListDData.plan_d_text == 'Using' }">
    <div class="d2-plan-card-name">{{ plansListDData.plan_d_title }}</div>
    <div class="d2-plan-card-price-row"><span class="d2-plan-card-price">${{ plansListDData.plan_d_label_amount }}</span><span class="d2-plan-card-unit">/{{lang['components']['Plan']['PlanD']['time_unit']}}</span></div>
    <ul class="d2-plan-card-features">
      <li v-for="(item, index) in description">
          <i class="fas fa-check"></i> {{ item }}
      </li>
    </ul>
    <button v-if="plansListDData.plan_d_show" class="d2-plan-card-btn upgrade" @click="handleChickPlan(141, 'D', '', 'fb')">
      {{ plansListDData.plan_d_text }}
    </button>
    <button v-else-if="!plansListDData.planHaveBind" class="d2-plan-card-btn upgrade" @click="handleChickPlan(141, 'D', '', 'fb')">
      {{lang['components']['Plan']['PlanD']['is_expired']}}
    </button>
    <button
      v-else
      class="d2-plan-card-btn payagain"
       v-if="isExpiredData && (plansListDData.plan_d_text == '使用中' || plansListDData.plan_d_text == 'Using')"
      @click="handleChickPlan(141, 'D', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanD']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanD',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListD:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  computed: {
    plansListDData: {
      get: function () {
        return this.plansListD
      },
      set: function (value) {
        this.$emit('update:plansListDData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListD.plan_d_description
    },
    isDisabled: function() {
       return this.plansListD.plan_d_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-D {
    &:hover {
      border: 2px #6298D7 solid;
    }
  }
</style>
